import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CartIcon } from 'assets';

const HeaderCart = () => {
  const { totalQuantity } = useSelector((state) => state.cart);

  return (
    <Link to='/cart' className='header-btn header-btn--cart'>
      <span className='header-btn--cart__img'>
        <CartIcon />
        <span className='header-btn--cart__counter'>{totalQuantity}</span>
      </span>
    </Link>
  );
};

export default HeaderCart;
